export default __webpack_public_path__ + "static/goodalways-fcb9b7398df1e0210ff8bbba23229ff2.png";